import { render, staticRenderFns } from "./SettingMenu.vue?vue&type=template&id=3b8e9683&scoped=true"
import script from "./SettingMenu.vue?vue&type=script&lang=ts"
export * from "./SettingMenu.vue?vue&type=script&lang=ts"
import style0 from "./SettingMenu.vue?vue&type=style&index=0&id=3b8e9683&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8e9683",
  null
  
)

export default component.exports